import React, { Component } from 'react';
import Select from 'react-select-plus';
import styled from 'styled-components';
import Icon from 'modules/common/components/Icon';
import debounce from 'lodash/debounce';
import { colors } from 'modules/common/styles';
import PropTypes from 'prop-types';
import { Alert, confirm } from 'modules/common/utils';
import {
  FormGroup,
  ControlLabel
} from '.';
export const SelectValue = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: -7px;
  padding-left: 25px;

  img {
    position: absolute;
    left: 0;
  }
`;

export const SelectOption = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const Avatar = styled.img`
  width: 20px;
  height: 20px;
  border-radius: 10px;
  background: ${colors.bgActive};
  object-fit: cover;
  float: left;
  margin-right: 5px;
`;

const SelectWrapper = styled.div`

  .Select-clear-zone {
    visibility: hidden;
  }
`;

const ClearButton = styled.div`
  position: absolute;
  right: 18px;
  font-size: 16px;
  top: 50%;
  width: 18px;
  z-index: 2;
  color: #999;
  line-height: 24px;
  margin-top: -14px;

  &:hover {
    color: #ea475d;
    cursor: pointer;
  }
`;

class SelectWithSearch extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedValues: props.initialValues,
      selectedOptions: props.selectedOptions,
      totalOptions: props.totalOptions
    };
  }

  content(option) {
    return (
      <span>
        <Avatar
          src={option.avatar ? option.avatar : '/images/avatar-colored.svg'}
        />
        {option.label}
      </span>
    );
  }

  selectItemRenderer(option, showAvatar, OptionWrapper) {
    if (!showAvatar) {
      return option.label;
    }

    return <OptionWrapper>{this.content(option)}</OptionWrapper>;
  }
  componentWillReceiveProps(nextProps) {
    // const { queryName, customQuery, generateOptions } = nextProps;
    // const { selectedValues } = this.state;
    // if (customQuery.loading !== this.props.customQuery.loading) {
    //   const datas = customQuery[queryName] || [];
    //   const totalOptions = this.state.totalOptions || [];
    //   const totalOptionsValues = totalOptions.map(option => option.value);
    //   const uniqueLoadedOptions = generateOptions(
    //     datas.filter(data => !totalOptionsValues.includes(data._id))
    //   );
    //   const updatedTotalOptions = [...totalOptions, ...uniqueLoadedOptions];
    //   const selectedOptions = updatedTotalOptions.filter(option =>
    //     selectedValues.includes(option.value)
    //   );
    //   this.setState({
    //     totalOptions: updatedTotalOptions,
    //     selectedOptions
    //   });
    // }
  }

  renderClearButton = () => {
    if (!this.props.multi) {
      return null;
    }

    const { selectedValues = [] } = this.state;

    if (selectedValues.length > 0) {
      return (
        <ClearButton onClick={this.onClear}>
          <Icon icon="times" />
        </ClearButton>
      );
    }

    return null;
  };

  onClear = e => {
    confirm().then(() => {
      this.props.onSelect([], this.props.name);
      this.setState({ selectedValues: [], selectedOptions: [] });
    });
  };

  render() {
    const { __ } = this.context;
    const {
      loading,
      label,
      onSelect,
      name,
      search,
      multi,
      customOption,
      showAvatar = true
    } = this.props;

    const { totalOptions, selectedValues } = this.state;

    const selectMultiple = ops => {
      const selectedOptionsValues = ops.map(option => option.value);

      onSelect(selectedOptionsValues, name);

      this.setState({
        selectedValues: selectedOptionsValues,
        selectedOptions: [...ops]
      });
    };

    const selectSingle = option => {
      console.log(`selectSingle`, option);
      const selectedOptionValue = option ? option.value : '';

      onSelect(selectedOptionValue, name);

      this.setState({
        selectedValues: [selectedOptionValue],
        selectedOptions: [{ ...option }]
      });
    };

    const onChange = multi ? selectMultiple : selectSingle;

    const onSearch = searchValue => {
      if (searchValue) {
        debounce(() => search(searchValue), 1000)();
      }
    };

    const onOpen = () => search('reload');

    const selectOptions = [...(totalOptions || [])];

    if (customOption) {
      selectOptions.unshift(customOption);
    }

    let optionRenderer;
    let valueRenderer;

    if (multi) {
      valueRenderer = option =>
        this.selectItemRenderer(option, showAvatar, SelectValue);

      optionRenderer = option =>
        this.selectItemRenderer(option, showAvatar, SelectOption);
    }

    console.log(`selectOptions --`, selectOptions);

    return (

      <SelectWrapper>
        <Select
          placeholder={__(label)}
          value={multi ? selectedValues : selectedValues[0]}
          loadingPlaceholder={__('Loading...')}
          isLoading={loading}
          onOpen={onOpen}
          onChange={onChange}
          optionRenderer={optionRenderer}
          valueRenderer={valueRenderer}
          onInputChange={onSearch}
          options={selectOptions}
          multi={multi}
        />
        {this.renderClearButton()}
      </SelectWrapper>
    );
  }
}
SelectWithSearch.contextTypes = {
  __: PropTypes.func
};
export default SelectWithSearch;



// WEBPACK FOOTER //
// ./src/modules/theme/theme1/common/components/form/SelectWithSearch.js